module.exports = __webpack_public_path__ + "img/branton-hero.4c1f6757.jpg";